import { Progress } from '@backstage/core-components';
import React, { Suspense } from 'react';

const LazyOpenApiDefinition = React.lazy(
  () => import('./OpenApiDefinition.esm.js').then((m) => ({
    default: m.OpenApiDefinition
  }))
);
const OpenApiDefinitionWidget = (props) => {
  var _a;
  const validSubmitMethods = (_a = props.supportedSubmitMethods) == null ? void 0 : _a.map(
    (method) => method.toLocaleLowerCase()
  );
  return /* @__PURE__ */ React.createElement(Suspense, { fallback: /* @__PURE__ */ React.createElement(Progress, null) }, /* @__PURE__ */ React.createElement(
    LazyOpenApiDefinition,
    {
      ...props,
      supportedSubmitMethods: validSubmitMethods
    }
  ));
};

export { OpenApiDefinitionWidget };
//# sourceMappingURL=OpenApiDefinitionWidget.esm.js.map
